import { isDateInPast } from './date';
import type { DateInput } from 'interface/common';

export const shouldHighlightPotentialEndDate = (endDate: DateInput, potentialEndDate: DateInput): boolean => {
  return !endDate && isDateInPast(potentialEndDate);
};
